import type { SunlightTimes } from 'types/sunlightTimes';
import sunlightTimeXPercentage from './sunlightTimeXPercentage';

// TODO: Replace with updated dayNightShading colors from Theme
const darkGray = '#ECEFF3';
const lightGray = 'rgba(236, 239, 243, .5)';

const transitionBackground = (
  nightColor: string,
  firstAndLastLightColor: string,
  dayColor: string,
  dawnXPercentage: number,
  duskXPercentage: number,
  sunriseXPercentage: number,
  sunsetXPercentage: number,
  offset: number,
) =>
  `linear-gradient(
    to right,
    ${nightColor} 0%,
    ${nightColor} ${(dawnXPercentage + offset) * 100}%,
    ${firstAndLastLightColor} ${(dawnXPercentage + offset) * 100}%,
    ${firstAndLastLightColor} ${(sunriseXPercentage + offset) * 100}%,
    ${dayColor} ${(sunriseXPercentage + offset) * 100}%,
    ${dayColor} ${(sunsetXPercentage + offset) * 100}%,
    ${firstAndLastLightColor} ${(sunsetXPercentage + offset) * 100}%,
    ${firstAndLastLightColor} ${(duskXPercentage + offset) * 100}%,
    ${nightColor} ${(duskXPercentage + offset) * 100}%,
    ${nightColor} 100%
  )`;

const getDayNightShadingBackground = ({
  sunlightTimes,
  offset = 0,
  dayIndex = 0,
}: {
  sunlightTimes: SunlightTimes;
  offset?: number;
  dayIndex?: number;
}) => {
  const dawnXPercentage = sunlightTimeXPercentage('dawn', dayIndex, sunlightTimes?.days) || 0;
  const duskXPercentage = sunlightTimeXPercentage('dusk', dayIndex, sunlightTimes?.days) || 0;
  const sunriseXPercentage = sunlightTimeXPercentage('sunrise', dayIndex, sunlightTimes?.days) || 0;
  const sunsetXPercentage = sunlightTimeXPercentage('sunset', dayIndex, sunlightTimes?.days) || 0;

  return transitionBackground(
    darkGray,
    lightGray,
    'white',
    dawnXPercentage,
    duskXPercentage,
    sunriseXPercentage,
    sunsetXPercentage,
    offset,
  );
};

export default getDayNightShadingBackground;
